import React from "react";
import { useState } from "react";
import Space from "../layout/Space";
import Icon1 from "../icons/Icon";
import { isColorTooDark } from "../models/OrgFunctions";

const Tag = ({ tag_folder_id, orgData, handleSetTag }) => {
  const intToHexColor = (colorint) => {
    // Extract ARGB components
    const alpha = (colorint >> 24) & 0xff;
    const red = (colorint >> 16) & 0xff;
    const green = (colorint >> 8) & 0xff;
    const blue = colorint & 0xff;

    // Convert each component to a 2-digit hex value and combine them
    return `#${[red, green, blue]
      .map((c) => c.toString(16).padStart(2, "0"))
      .join("")}`;
  };

  const handleGoToTags = () => {
    window.location.href = "/tags";
  };

  const [tags_hover, setTagsHover] = useState({});

  return (
    <div className="text-xs bg-white text-white rounded-3xl h-fit max-w-c500 flex p-6 flex-col gap-2">
      <div className="flex flex-row justify-between">
        {" "}
        <div className="text-h1 text-black">Choisissez un tag</div>{" "}
        <div className="cursor-pointer" onClick={handleGoToTags}>
          <Icon1 icon_name="settings" height="20px" width="40px" />
        </div>
      </div>
      <Space y={10} />
      <div className="flex flex-wrap">
        <div
          onClick={() => handleSetTag("pas de tag", tag_folder_id)}
          onMouseEnter={() => setTagsHover({ "pas de tag": true })}
          onMouseLeave={() => setTagsHover({})}
          key="pas de tag"
          className="bg-primary_l2 text-gray-800 px-2 py-0.5 m-1 w-fit h-fit rounded-3xl  cursor-pointer"
          style={{
            backgroundColor: tags_hover["pas de tag"] ? "grey" : "lightgrey",

            color: "black",
          }}
        >
          Pas de tag
        </div>
        <div
          onClick={() => handleSetTag("#nouveau", tag_folder_id)}
          onMouseEnter={() => setTagsHover({ "#nouveau": true })}
          onMouseLeave={() => setTagsHover({})}
          key="#nouveau"
          className="bg-primary_l2 text-gray-800 px-1 py-0.5 m-1 w-fit h-fit rounded-xl  cursor-pointer"
          style={{
            backgroundColor: tags_hover["#nouveau"] ? "grey" : "#d9f0ff",

            color: "black",
          }}
        >
          #nouveau
        </div>
        {orgData.tags?.map((tag, index) => (
          <div
            key={index}
            onClick={() => handleSetTag(tag.nom, tag_folder_id)}
            onMouseEnter={() => setTagsHover({ [tag.nom]: true })}
            onMouseLeave={() => setTagsHover({})}
            className=" text-gray-800 rounded-xl px-2 py-1  m-1 w-fit h-fit cursor-pointer"
            style={{
              backgroundColor: tags_hover[tag.nom]
                ? "grey"
                : intToHexColor(tag.colorint),
              color: isColorTooDark(intToHexColor(tag.colorint))
                ? "white"
                : "black",
            }}
          >
            {tag.nom}
          </div>
        ))}
      </div>
    </div>
  );
};
export default Tag;
